"use client";

import {
  FeatureHighlight,
  MainLink,
  SecondaryLink,
} from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { sizedFloorPlanExample } from "../../../../public/images/floor-plans";
import { sizedFloorPlanDetail } from "../../../../public/images/logos";

const ProductDescription = () => {
  const tC = useTranslations("common");
  const tS = useTranslations("sized.productDescription");

  return (
    <div className="gs--page-column py-16" id="section-1">
      <div className="flex flex-col gap-10">
        <FeatureHighlight
          src={sizedFloorPlanDetail}
          alt={"Bemasster Grundriss Detail"}
          title={tS("title")}
          text={tS("text")}
        />

        {/* Explanation */}
        <div className="flex flex-col items-center gap-10 md:flex-row">
          <div className="flex flex-col gap-10">
            <Separator />
            <p className="text-ring">{tS("explanation")}</p>
            <Separator />
          </div>
          <Image
            src={sizedFloorPlanExample}
            alt={"Beispiel bemasster Grundriss"}
            width={400}
            className="w-[400px]"
            loading="lazy"
          />
        </div>

        <div className="flex-start flex flex-col gap-5 sm:flex-row sm:items-center">
          <MainLink
            href="/user/order-sized-floor-plan"
            title={tC("nowOrder")}
          />
          <SecondaryLink href={"/grundriss-designs"} title={tC("ourDesigns")} />
        </div>
      </div>
    </div>
  );
};

export default ProductDescription;
